const lang = {
  about_paid_plans: '有料アカウントについて',
  application_details: 'お申込み詳細',
  individual_contract: '有料アカウント（１年間）',
  unit_price: '単価：¥26,400-（税込）',
  handle_person_info: '個人情報の取り扱い',
  notation_based_on_sctl: '特定商品取引法に基づく表記',
  agree_and_next_info: 'をご確認の上、同意いただければ［同意して次へ］ボタンを押して、支払い方法入力画面へお進みください。',
  agree_and_continue: '申し込み情報を入力する',
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/applicationDetails.js